module.exports = __webpack_public_path__ + "static/media/square_checkmark_active.5fadf150.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/square_checkmark_active.svg
// module id = 9
// module chunks = 0